import { Factory, ProjectActions } from '@octopus-do/octopus-project-core'

import { InitialTabId } from './initialTabId'

export const InitTabAction = ProjectActions.tabs.add({
  items: [
    Factory.tab({
      id: InitialTabId,
      title: 'Sitemap ver.1',
    }),
  ],
  index: 0,
  parents: [],
})
